import React, { useState } from "react";
import { toast } from "react-toastify";
import api from "../../utils/api";
import { handleModalAction } from "../../utils/helpers/handleModalAction";

const ResetPasswordModal = ({ user }) => {
  const [loading, setLoading] = useState(false);

  const handleResetPassword = async () => {
    setLoading(true);
    try {
      const res = await api.patch("/user/set-auto-genrate-password", {
        id: user?._id,
      });

      // Prefer checking the HTTP status or a success flag
      if (res.status === 200 && res.data?.status) {
        toast.success("User's password has been reset successfully.");
        handleModalAction("resetPasswordModal", "hide");
      } else {
        toast.error(res.data?.message || "Something went wrong.");
      }
    } catch (error) {
      console.error("Reset failed:", error);
      const message =
        error.response?.data?.message ||
        "Network error while resetting password.";
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="modal fade"
      id="resetPasswordModal"
      tabIndex="-1"
      aria-labelledby="resetPasswordModalLabel"
      aria-hidden="true"
    >
      <div className="modal-dialog">
        <div className="modal-content">
          <div className="modal-header">
            <h4 className="modal-title" id="resetPasswordModalLabel">
              Reset Password
            </h4>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-body">
            <p className="fs-6">
              Are you sure you want to reset the password for{" "}
              <strong className="text-capitalize">{user?.name}</strong>?
            </p>
            <p className="fw-bold fs-6">
              The new password is: <span className="text-dark">123456</span>
            </p>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleResetPassword}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Resetting...
                </>
              ) : (
                "Confirm Reset"
              )}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordModal;
